/**
 * Generado por scripts/scaffold-module.ts el 2026-07-23.
 * Rutas del módulo Productos.
 *
 * Este archivo es auto-cargado por src/router/routes.ts via import.meta.glob.
 * NO necesitas registrarlo manualmente en ningún otro sitio.
 */
import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: '/productos',
    name: 'productos.index',
    component: () => import('./views/ProductosIndex.vue'),
    meta: {
      layout: 'default',
      requiresAuth: true,
      requiresPermission: 'productos.read',
      title: 'Productos',
    },
  },
  {
    path: '/productos/:id/pagina',
    name: 'productos.pagina',
    component: () => import('./views/ProductoPaginaEditor.vue'),
    meta: {
      layout: 'auth',
      requiresAuth: true,
      requiresPermission: 'productos.update',
      breadcrumb: 'Página del producto',
    },
  },
]

export default routes
